<template>
    <div v-if="overview" class="justify-content-center">
        <div v-if="!activeSie" class="h4 text-white pt-3" style="padding-left: 34px; padding-top: 6px; padding-bottom: 10px;">
            Bolagsinfo
        </div>
        <div v-else class="h4 text-black pt-3 bcGreen activeSie" style="padding-left: 34px; padding-top: 6px; padding-bottom: 10px;">
            Bolagsinfo (SIE) <span style="float: right; padding-right: 4px;"><button style="background-color: Transparent;outline:none;border: none;color: black;" @click="clearSie()"><I name="cross-circle" style="font-size: 30px; position:relative;top: -6px;"/></button></span>
        </div>

        <router-link class="row mx-0 rlink" :to="{ name: 'overview', params: { OrgNr } }">
            <div class="h5 my-2 p-1 text-white" style="margin-left: 22px;">
                <I name="pushpin" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Översikt
            </div>
        </router-link>

       <router-link v-if="(overview && overview.DATE_TO) || activeSie" class="row mx-0 rlink" :to="{ name: 'compass', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="compass2" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Bolagskompass <span v-if="activeSie" class="circle"></span>
           </div>
       </router-link>

       <router-link v-if="(overview && overview.DATE_TO) || activeSie" class="row mx-0 rlink" :to="{ name: 'compassyears', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="layers" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Flerårskompass <span v-if="activeSie" class="circle"></span>
           </div>
       </router-link>

       <router-link v-if="(overview && overview.DATE_TO) || activeSie" class="row mx-0 rlink" :to="{ name: 'profitlossdiagram', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="chart-bars" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Resultatdiagram <span v-if="activeSie" class="circle"></span>
           </div>
       </router-link>

       <router-link v-if="includeValuation && (overview && overview.DATE_TO || activeSie)" class="row mx-0 rlink" :to="{ name: 'valuation', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="trophy2" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Kassaflödesvärdering <span v-if="activeSie" class="circle"></span>
           </div>
       </router-link>

       <router-link v-if="(overview && overview.DATE_TO) || activeSie" class="row mx-0 rlink" :to="{ name: 'profitloss', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="calculator" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Resultaträkning <span v-if="activeSie" class="circle"></span>
           </div>
       </router-link>

       <router-link v-if="(overview && overview.DATE_TO) || activeSie" class="row mx-0 rlink" :to="{ name: 'balance', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="balance" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Balansräkning <span v-if="activeSie" class="circle"></span>
           </div>
       </router-link>

        <router-link class="row mx-0 rlink" :to="{ name: 'sie', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="cloud-upload" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>SIE
           </div>
       </router-link>

       <router-link class="row mx-0 rlink" :to="{ name: 'documents', params: { OrgNr } }">
           <div class="w-100 h5 my-2 p-1 text-white" style="margin-left: 22px;">
               <I name="clipboard-text" style="font-size: 30px; margin-bottom: 5px; margin-right: 10px;"/>Dokument
           </div>
       </router-link>

    </div>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator';
    import user from '@/store/modules/user';
    import CompanyMixin from '@/mixins/CompanyMixin';
    import {cards} from '@/config';

    @Component({mixins: [CompanyMixin]})
    export default class SidebarCompany extends Vue {
        clearSie() {
            user.setActiveSie(null);
        }
        get activeSie() {
            return user.activeSie !== null;
        }
        get OrgNr() {
            return this.$route.params.OrgNr;
        }
        get includeValuation() {
            return cards.includes('valuation');
        }
    }

</script>

<style scoped lang="scss">
    $active-bar: get('colors.Tertiary');
    $inactive-bg: get('colors.Primary');
    $active-bg: get('colors.Secondary');

    .rlink {
        cursor: pointer;
        border-left: 4px solid $inactive-bg;
    }
    .rlink:hover {
        background-color: $active-bg;
        text-decoration: none;
        border-left: 4px solid $active-bg;
    }
    .rlink.router-link-exact-active:hover {
        border-left: 4px solid $active-bar;
    }
    .rlink.router-link-exact-active {
        background-color: $active-bg;
        cursor: pointer;
        border-left: 4px solid $active-bar;
    }

    .activeSie {
        border-radius: 8px;
    }

    .circle {
        float: right;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid col('colors.Green');
        opacity: 1;
        margin-top: 6px;
        margin-right: 12px;
    }
</style>
